export const chapter3 = [

    //page 24
    'Finally, they were free of the canopy‘s draining power,',
    'But now immersed in the stench of the bog, musky and sour,',
    'They all drew a deep breath, glad they had that in the past,',
    'But no sunny sky was greeting them it was dull and overcast,',
    'Plants barely clung to life here and trees were dead wood,',
    'They stomped and waded on as best they could,',
    'Garson piped up as he struggled to dislodge his boot,',
    '“Tell me Andell how you know this place and it‘s loot?”',
    'Andell‘s face fell low, memories flooded back to her,',
    '“My late husband and I... details I would not prefer”,',
    '“Let‘s just say, I used to live not too far from here”,',
    '“We had one failed attempt to stop raids last year”,',

    //page 25
    'Garson replied “I am sorry for your loss, we‘ll set it right”,',
    '“Let‘s push on and reach there before falls another night”,',
    'They came to a point the mud blended into murky water,',
    'Sigg looked around, “how can we proceed further?”',
    'Andell pointed into the gloomy distance with her finger,',
    '“The vile one is out there, awaiting the death I‘ll bring her”,',
    'They reluctantly waded deeper into muck up to their chests,',
    'Foul floating spine-back eggs meant they neared the nest,',
    'As they pressed on the eggs became larger, first the size of a fist,',
    'Then watermelon and larger were seen amid the mist,',
    '“Draw your weapons, we must be close,” Sigg directed,',
    'Garson tried in vain to keep his cut from getting infected,',
    'As they were drawn deeper into the swamp most foul,',
    'They began to hear a guttural beastly howl,',
    'Andell froze, her lost love gripping her by the throat,',
    'Dane raised his blade, “I‘ll gut her...“ he began to gloat,',
    'Dirty water splashed high in to the air as tentacles burst out,',
    'The brood-mother‘s roar demanded they all hastily turnabout,',
    'She was a mess of flesh, bloated, pocked and swollen,',
    'Her maw was lined with sharp teeth and smelt like a colon,',
    'Dane charged forward swinging his blade calling for vengeance,',
    'He lopped through a tentacle and was rewarded with a rare pungence,',

    //page 26
    'Torgen and Corl rushed in eager to hack off their pound of flesh,',
    'The large beast whipped claws over them in a mad thresh,',
    'She grabbed Corl and wrested him out of the water suspended,',
    '“Draw her back to shallower water!” Sigg recommended,',
    'With a large splash Torgen and Dane got pulled under,',
    'Sigg hoped it was not too late to correct this blunder,',
    'Dane cried out in pain for a moment, till the water went red,',
    'It was clear to everyone that he was now dead,',
    'Garson had been busy assembling something from pocket and pouch,',
    'Wooden frame, rope spools and metal spikes to gouge,',
    '“Stand back!” He cautioned and loosed a net projectile,',
    'Barbs punched into the creature and rope tangled it immobile,',
    'Sigg hacked away and Corl fell free of her deadly grasp,',
    'Torgen popped up out of the ooze and began to gasp,',
    '“Retreat!” Sigg yelled as they sloshed back as best they could,',
    'He knew fighting in her element would be no good,',
    'The brood-mother wriggled and fought herself in a knot,',
    'The rope was holding, but not for long Sigg thought,',
    'Tears ran down Andell‘s cheek, she had sunk in to the fear,',
    'Through the rope the beast began to rip and tear,',
    'Torgen grabbed her and they waded back to water knee deep,',
    'The rest followed behind with a trudge and a leap,',

    //page 27
    'A howl shook the air and her kin echoed back the call,',
    'The party heard splashing from around them all,',
    'The mother of broods stayed back in her depth waiting,',
    'She knew her spawn would soon begin feasting,',
    '“Andell snap out of it, we need you for this fight”,',
    'Sigg checked her for injuries, but she seemed alright,',
    'As the spine-backs drew in she dropped in to the mud of despair,',
    'Her resolve had been strong but now nothing seemed clear,',
    '“It‘s up to us to kill each one of this filthy spawn...”',
    'But before he could finish they were set upon,',
    'Torgen, Corl and Sigg swung their blades fuelled with a fresh hate, ',
    'Garson quickly mixed a few chemicals stashing it before it was too late,',
    'The air was filled with cries and from fresh wounds blood splash,',
    'Torgen threw his mace at speed lining up heads to smash,',
    'The blades of Corl went into overdrive puncturing every beast he struck,',
    'With a twist and pull he liberated their innards to splatter into the muck,',
    'Sigg punched one with his shield and sent it back reeling,',
    'He followed up with slash and it fell into the mud squealing,',
    '“I need a few more minutes to complete the blood-acid brew”,',
    'Garson swung his axe into the closest spine-back and split it in two,',
    'Sigg drew upon his memories of home in Cragknoll as he bled,',
    '“Andell fight now -for your family”, as he lay his hand upon her head,',

    //page 28
    'Through a pinhole gap in the overcast sky escaped a flicker of sunlight,',
    'With it a memory of husband‘s smile, Andell stood again ready to fight,',
    '“If this is our last stand, killing her kin will my vengeance sate”,',
    'She pointed her blade at the brood-mother saturated in hate,',
    'A scream burst from her lungs as she severed beast limbs and cut,',
    'She stabbed one in the face, cut a throat and another in the gut,',
    '“Drive them into the mud!” Sigg roared as he cut another one down,',
    'He kicked it back and stomped into the ooze blended red and brown,',
    'They fought all the harder and brought their foul enemy low,',
    'This was not how the brood-mother thought it would go,',
    'Spine-back reinforcements depleted, Garson made good use of the time,',
    'He drew a few vials, mixed in blood, a dark powder and caustic lime,',
    'He passed the solution to Andell, ',
    '“Send that ugly squid back to Hell”,',
    'She nodded her thanks and hurled it at the brood-mother at pace,',
    'It smashed onto her head and the concoction dripped over her face,',
    'An ear-rending scream of pain cut the air for a mile,',
    'Andell looked on “Take it!”, on her face spread a smile,',
    'She thrashed and rolled about but her efforts made it worse,',
    'The acid devoured her flesh to the bone like a powerful curse,',
    'In mere minutes her tentacles gave up their last twitch,',
    'Torgen spoke for them all “Good riddance you bitch!”,',

    //page 29
    'No more of her evil spawn would lay ruin upon the surrounding lands,',
    'They felt vindicated that despite their losses she lay dead at their hands,',
    'Sigg felt his heart pace begin to slow and his breath finally caught,',
    'His body alerted him to all the injuries that he had just got,',
    'They dressed their wounds and paid Dane respect with a cairn of stone,',
    '“Andell, I‘ve heard these beasts store their loot, is this location known?”',
    'She replied to Sigg “Their tracks converge to a den on that far mound”,',
    '“Let’s go, get what need and escape to somewhere safe and sound”,',
    'No sooner than the direction left her lips Sigg began to move,',
    'This trip being worth the spent lives he had still to prove,',
    'Despair still tried to retain its hold, so too did fear,',
    'But he felt hope rise inside him, his hammer must be near,',
    'They squelched and waded past brood-mother‘s carcass,',
    'Which was now the work of a violent chemical artist,',
    'Mud could no longer hold them back after what they saw,',
    'The mound was a heap of loot piled up to make a floor,',
    'Strong-boxes, barrels, crates, weapons, goods, all sorts of spoil,',
    'They shared a well-earned smile a reward for their hard toil,',
    'They began to rummage through the valuables and the junk,',
    'Corl gasped finding a collection of jewels filling a small trunk,',
    '“Just this will set our village right for years to come!”',
    'Torgen danced over carrying more “Lets get all of this home”,',

    //page 30
    'Garson began to catalogue rare items until now thought lost,',
    'His mind was building his next project confident he could pay the cost,',
    'Andell‘s eyes remained on the corpse of her late husband’s killer,',
    'But was happy to scoop up a bottle of expensive liquor,',
    'Sigg dug into the pile of steel some given in to rust,',
    'Blades and axes, but nothing to sate his hammer lust,',
    'Andell sat in the mud her eyes now seemed to carry extra weight,',
    '“My brew is wearing off, I must return, I can‘t be late”,',
    'But the others were all distracted by their prize find,',
    'It was not for lack of respect that they paid her no mind,',
    'Finally, her body could resist no longer she fell unconscious,',
    'Corl rushed over “Andell! Wake up!” She was unresponsive,',
    'Garson checked her vitals growing concern on his face,',
    '“We‘ll need to leave now to get her away from this place”,',
    'After a moment of stuffing their pockets Torgen and Corl raced over,',
    '“Here,” Garson pointed “we can use these planks to help carry her”',
    'Working together they built under Garson‘s skilled instruction,',
    'They loaded Andell on and set towards the village direction,',
    'Sigg still had not found that which he desperately sought,',
    'He stood to leave empty handed after with his mind he fought,',
    '“Let‘s take her to the village herbalist, someone with healing skill”,',
    'Sigg wondered if it was the swamp making her feel ill,',

    //page 31
    '“Incoming!” Corl called to Torgen on other end of the stretcher-makeshift,',
    'Fighting would be hard with the two of them giving Andell a lift,',
    'A pack of pig-rats made their way over the swamp most foul,',
    'When they saw their dead mother they roared a howl,',
    'Sigg scampered down from the loot-piled mound,',
    'But he tripped and fell splat into the muddy ground,',
    'He looked at his feet and saw a handle peeking out of the dirt,',
    'He took a double take to try and confirm he was alert,',
    'Garson stood between the beasts and his ill friend,',
    '“Get over here Sigg! We need you to help defend”,',
    'Sigg felt what he saw was more precious than gold,',
    'He reached out his hand, the mud released its hold, ',
    'He had found the relic hammer of his long past ancestor,',
    'He swung it above his head in a victorious gesture,',
    'He proclaimed a war cry that stopped the spine-backs in their tracks,',
    'All of them broke upon Sigg with his hammer and Garson‘s axe,',
    '“Toothbreaker ignite!” He proclaimed its ancient name,',
    'The hammer broke free of the muck as it burst into flame,',
    'Sigg advanced swinging, to him the odds did not matter,',
    'He smashed aside his foe and the pig-rats began to scatter,',
    'He wielded the mighty hammer with expert martial skill,',
    'He shattered bone, caved in heads, kill after kill,',

    //page 32
    'He slaughtered and butchered them all with impunity,',
    'Garson cut down more still and made good the opportunity,',
    'The hammer satisfied with death the inner flame died out,',
    '“For the honour of Cragknoll!” Sigg cried out,',
    '“Incredible! The craftsmanship on that is beyond compare”,',
    '“I‘d love to examine it, I‘ve not seen it’s like elsewhere”,',
    '“Perhaps Garson, lets first make it back to safety”,',
    '“I hope to make a quick pace and remedy Andell‘s frailty”,',
    '“Agreed, I expect if we wait here more of those things will appear”,',
    '“None of her wounds are serious but it‘s poison that I fear”,',
    'So the men followed their tracks back and made their escape,',
    'They killed a few more beasts and only gained a few cuts and a scrape,',
    'Andell murmured and muttered like she was in a dream,',
    '“Two leaves, stir, no three!” Nobody knew what this could mean,',
    'At last, up ahead they saw plants and trees lush and green,',
    'After such a slog through the muck they were glad to change scene,',
    'They put the stinking swamp behind them and entered the forest,',
    'They were all nearing the point of exhaustion if they were being honest,',
    'They stuck to the path they burnt in the canopy on the way in,',
    'The air gradually stank less like the swamp made them grin,',
    'They trudged on at a slowing pace till they found,',
    'The small cairn where Seb was buried in the ground,',

    //page 33
    '“Shall we stop here for the night? I really need to rest”,',
    'Corl explained as he and Torgen stopped, both hard-pressed,',
    'Sigg looked to Garson and they shared a nod,',
    '“Just a few hours to recoup then on we plod”,',
    'Corl and Torgen sat and reflected by Seb‘s grave,',
    '“We have lost, but a multitude more we did save”,',
    'Their muscles and injuries lapped up the reprieve,',
    'But it felt all too soon and it was time to leave,',
    'Sigg stood up “Come, let‘s sleep within the walls”,',
    'Garson agreed “Yes, away from what bites and crawls”,',
    'Drawing upon their deepest reserves they pushed on,',
    'One pained step at a time till the forest was now gone,',
    'They had found the dirt trail that‘d lead them safely back,',
    'They spent their last energy, none left if they got attacked,',
    'Sigg realized they were starting to suffer dehydration,',
    '“We can do it, think of home, use it to aid your determination”,',
    'With their strength day‘s light slowly began to fade away,',
    'The marched on at a pace that made less headway,',
    '“The gates!” Torgen cried, sweet words to every ear,',
    'They started counting the steps as it drew near,',

];